var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user.features.agency && _vm.user.agency)?_c('v-dropdown',{attrs:{"label":_vm.user.agency.name,"items":_vm.items,"menu-position":'br',"show-selected":false,"size":_vm.size},on:{"change":_vm.onChange}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }